export default {"src":"/_next/static/media/stakeholder-collaboration.2ee73c54.svg","height":355,"width":355,"blurWidth":0,"blurHeight":0};